import { Box, Icon, Text } from '@nimbus-ds/components';
import { ChevronRightIcon } from '@nimbus-ds/icons';
import { DataList } from '@nimbus-ds/patterns';
import { generatePath, Link } from 'react-router-dom';
import { ProductTransferListResponseDto } from '@tiendanube/common';
import { dateFormat, Format } from 'commons/utils/date';
import { CATALOG_ROUTES } from 'domains/Catalog/catalogRoutes';
import TransferListRowSkeleton from './TransferListRowSkeleton';
import { TransferStatus } from '../../../components';

interface TransferListRowProps {
  transfer: ProductTransferListResponseDto[number];
}

function TransferListRow({
  transfer: {
    id,
    number,
    originLocation,
    destinationLocation,
    transferDate,
    status,
  },
}: Readonly<TransferListRowProps>) {
  return (
    <DataList.Row backgroundColor="transparent">
      <Box display="grid" gridTemplateColumns="1fr 1fr" gap="1-5">
        <Link
          className="nimbus--link nimbus--link--primary nimbus--link--base"
          to={generatePath(CATALOG_ROUTES.viewTransferDetails, { id })}
        >
          #{number}
        </Link>
        <Box display="flex" justifyContent="flex-end">
          <Text>{dateFormat(transferDate, Format.DAY_MONTH)}</Text>
        </Box>
        <div
          style={{
            gridColumn: '1 / -1',
            display: 'flex',
            gap: 'var(--nimbus-spacing-2)',
          }}
        >
          <Text>{originLocation}</Text>
          <Icon source={<ChevronRightIcon />} color="neutral-textLow" />
          <Text>{destinationLocation}</Text>
        </div>
        <Box marginTop="1-5">
          <TransferStatus status={status} />
        </Box>
      </Box>
    </DataList.Row>
  );
}

TransferListRow.Skeleton = TransferListRowSkeleton;

export default TransferListRow;
